import { ReactNode } from 'react'
import { Box, Container, Grid } from '@mui/material'

import ComparisonTable from '@/components/base/comparison-table'

type ACFTable = {
  caption?: string
  columns?: { title?: string }[]
  rows?: {
    label?: string
    cells?: {
      type?: 'text' | 'check' | 'dash' | 'node'
      text_value?: string
      node_value?: ReactNode
    }[]
  }[]
}

export function mapAcfComparisonTable(acf: ACFTable) {
  const caption = acf.caption ?? ''

  const columns = (acf.columns ?? []).map((c) => c.title?.trim()).filter(Boolean) as string[]

  const rows = (acf.rows ?? []).map((r) => {
    const label = r.label ?? ''

    const cells = (r.cells ?? []).map((c) => {
      switch (c.type) {
        case 'text':
          return { type: 'text' as const, value: c.text_value ?? '' }
        case 'check':
          return { type: 'check' as const }
        case 'dash':
          return { type: 'dash' as const }
        case 'node':
          return { type: 'node' as const, value: c.node_value ?? null }
        default:
          return { type: 'dash' as const }
      }
    })

    // (opzionale) normalizza lunghezza celle = colonne
    const normalized =
      cells.length >= columns.length
        ? cells.slice(0, columns.length)
        : [
            ...cells,
            ...Array.from({ length: columns.length - cells.length }, () => ({
              type: 'dash' as const
            }))
          ]

    return { label, cells: normalized }
  })

  return { caption, columns, rows }
}

const Table = ({ caption, columns, rows }: ACFTable) => {
  const data = mapAcfComparisonTable({ caption, columns, rows })
  return (
    <Box>
      <Container>
        <Grid container spacing={4}>
          <ComparisonTable {...data} />
        </Grid>
      </Container>
    </Box>
  )
}

export default Table
